<div class="row pt-3 mt-3">
  <div class="col-8">
    <h1 [innerHTML]="heading"></h1>
    <h3 class="text-secondary fw-normal">{{ subHeading }}</h3>
  </div>
  @if (imageUrl != '') {
    <div class="col-4">
      <img src="{{ imageUrl }}" class="img-thumbnail" alt="">
    </div>
  }
</div>
<hr>
